import { render, staticRenderFns } from "./AiResponseForm.vue?vue&type=template&id=06430a02"
import script from "./AiResponseForm.vue?vue&type=script&lang=js"
export * from "./AiResponseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports